"use strict";

function connectionOf(integration) {
    return (integration.configuration && integration.configuration.connection) || integration.connection || {};
}

function classifyIntegration(integration) {
    const conn = connectionOf(integration);
    const url = typeof conn.url === "string" ? conn.url.trim() : "";
    const sheet = conn.sheet;

    if (conn.urlType === "voolks_sheet" || (sheet && sheet.fileId)) {
        return "sheet";
    }
    if (!url) {
        return "noUrl";
    }
    if (/sheets\.googleapis\.com/i.test(url)) {
        return "google";
    }
    if (/^https?:\/\//i.test(url)) {
        return "external";
    }
    return null;
}

function collectUserIds(form) {
    const ids = [];
    (form.validate_users || []).forEach(function (user) {
        if (user && user.id) {
            ids.push(user.id);
        }
    });
    (form.validate_defined || []).forEach(function (step) {
        (step.validate_users || []).forEach(function (user) {
            if (user && user.id) {
                ids.push(user.id);
            }
        });
    });
    return ids;
}

function hasTagMasks(form) {
    return (form.validate_defined || []).some(function (step) {
        return (step.validate_tagsMask || []).some(function (tag) {
            return !!tag;
        });
    });
}

function hasOriginLogo(reportConfig) {
    if (!reportConfig) {
        return false;
    }
    const logo = reportConfig.logo;
    if (typeof logo === "string" && logo && logo !== "false" && /containers\/|https?:\/\//i.test(logo)) {
        return true;
    }
    const html = (reportConfig.customHeader || "") + (reportConfig.customFooter || "");
    return /src="[^"]*containers\/|src="https?:\/\//i.test(html);
}

function reviewImport(fileContent, createIds) {
    const form = (fileContent && fileContent.form) || {};
    let integrations = (fileContent && fileContent.integrations) || [];
    if (createIds) {
        integrations = integrations.filter(function (integration) {
            return !!createIds[integration.id];
        });
    }
    let reportConfig = fileContent && fileContent.reportConfig;
    if (Array.isArray(reportConfig)) {
        reportConfig = reportConfig[0];
    }

    const notes = [];
    const userIds = collectUserIds(form);
    if (userIds.length) {
        notes.push({ id: "USERS", params: { count: userIds.length } });
    }
    if (hasTagMasks(form)) {
        notes.push({ id: "TAGS" });
    }

    const grouped = { external: [], sheet: [], google: [], noUrl: [] };
    integrations.forEach(function (integration) {
        const kind = classifyIntegration(integration);
        if (kind && grouped[kind]) {
            grouped[kind].push(integration.name || integration.id);
        }
    });

    if (grouped.external.length) {
        notes.push({ id: "EXTERNAL", params: { names: grouped.external.join(", ") } });
    }
    if (grouped.sheet.length) {
        notes.push({ id: "SHEETS", params: { names: grouped.sheet.join(", ") } });
    }
    if (grouped.google.length) {
        notes.push({ id: "GOOGLE", params: { names: grouped.google.join(", ") } });
    }
    if (grouped.noUrl.length) {
        notes.push({ id: "NO_URL", params: { names: grouped.noUrl.join(", ") } });
    }
    if (hasOriginLogo(reportConfig)) {
        notes.push({ id: "LOGO" });
    }
    if (form.graphId) {
        notes.push({ id: "GRAPH" });
    }
    notes.push({ id: "TEAMS" });

    return notes;
}

module.exports = reviewImport;
